import styled from 'styled-components';

export const TextWrapper = styled.div`
  padding: 0 16px;
  margin-bottom: 32px;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  color: ${p => p.theme.colors['neutral']['700']};
`;

export const SuccessWrapper = styled.div`
  text-align: center;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;

export const TermsWrapper = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${p => p.theme.colors['neutral']['500']};
  margin-top: 24px;
`;
